import { CheckPermissionLayout } from 'layouts';
import { RouteObject } from 'react-router-dom';
import { PERMISSION } from 'utils';
import { ROUTE } from './constants';
import { lazy } from 'react';

export const accessSycCustomerRoute: RouteObject[] = [
  {
    element: <CheckPermissionLayout permission={[PERMISSION.REQUEST_SYNC_CUSTOMER]} />,
    children: [
      {
        path: ROUTE.SYNC_CUSTOMER,
        children: [
          {
            index: true,
            Component: lazy(() => import('pages/SyncCustomer'))
          }
        ]
      }
    ]
  }
];
